import React from 'react';

const ChooseSide = () => <div>I am a simple page who Shravan will now replace</div>;

export default ChooseSide;
